import { render } from "./OrderItemPlaceholder.vue?vue&type=template&id=6b411ef6"
import script from "./OrderItemPlaceholder.vue?vue&type=script&lang=js"
export * from "./OrderItemPlaceholder.vue?vue&type=script&lang=js"

import "./OrderItemPlaceholder.vue?vue&type=style&index=0&id=6b411ef6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__